/**
 * Black Friday ticker: hovering (or focusing inside) the band eases the scroll down to a crawl
 * instead of stopping it, then eases it back up on the way out. CSS can only pause an animation,
 * so this tweens the CSS animation's playbackRate.
 */

const SLOW_RATE = 0.25;
const DURATION = 700;
const bound = new WeakSet();

/** @param {number} t */
const easeInOut = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

/**
 * @param {HTMLElement} band
 */
function bind(band) {
  if (bound.has(band)) return;
  bound.add(band);

  const track = band.querySelector('.bf-ticker__track');
  if (!track) return;

  /** @type {number|undefined} */
  let frame;
  let rate = 1;

  /** @param {number} target */
  const tweenTo = (target) => {
    const animation = track.getAnimations()[0];
    if (!animation) return;
    if (frame) cancelAnimationFrame(frame);

    const from = rate;
    const start = performance.now();
    const step = (/** @type {number} */ now) => {
      const progress = Math.min(1, (now - start) / DURATION);
      rate = from + (target - from) * easeInOut(progress);
      animation.playbackRate = rate;
      frame = progress < 1 ? requestAnimationFrame(step) : undefined;
    };
    frame = requestAnimationFrame(step);
  };

  const slow = () => tweenTo(SLOW_RATE);
  const resume = () => {
    if (!band.matches(':hover') && !band.contains(document.activeElement)) tweenTo(1);
  };

  band.addEventListener('pointerenter', (event) => {
    if (event.pointerType === 'mouse' || event.pointerType === 'pen') slow();
  });
  band.addEventListener('pointerleave', resume);
  band.addEventListener('focusin', slow);
  band.addEventListener('focusout', () => requestAnimationFrame(resume));
}

function init() {
  document.querySelectorAll('.bf-ticker').forEach((band) => bind(/** @type {HTMLElement} */ (band)));
}

init();
document.addEventListener('shopify:section:load', init);
